<template>
  <div class="page-content">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <h4 class="h4-white">Links Úteis</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkUteisActions",
  methods: {
    getPageLista: function() {
      this.$router.push("/LinkUteisLista");
    },
    getPageCadastro: function() {
      this.$router.push("/LinkUteisCadastro");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/linkUteis/LinkUteisActions.vue